<script>
import { createFromIconfontCN } from '@ant-design/icons-vue'

export default createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_2361349_8m7qlyi63aj.js',
  extraCommonProps: {
    class: 'icon'
  }
})
</script>
